import { PendingAnnouncementsResponse } from '@/types/announcement';

export const mockPendingAnnouncements: PendingAnnouncementsResponse = {
  announcements: [
    {
      id: 'ann_01JWCRX9P0000000000000001',
      title: 'simplified-crypto-deposits',
      priority: 100,
      steps: [
        {
          order: 0,
          title: {
            en: 'Simpler crypto deposits',
            es: 'Depósitos cripto más simples',
            pt: 'Depósitos cripto simplificados',
          },
          body: {
            en: "We've streamlined how you deposit USDC and USDT. The new flow is faster and requires fewer steps.",
            es: 'Hemos simplificado cómo depositas USDC y USDT. El nuevo flujo es más rápido y requiere menos pasos.',
            pt: 'Simplificamos como você deposita USDC e USDT. O novo fluxo é mais rápido e requer menos etapas.',
          },
          imageUrl:
            'https://img.freepik.com/vetores-gratis/painel-de-infografico-de-modelo-de-painel-de-usuario_23-2148378206.jpg?semt=ais_hybrid&w=740&q=80',
        },
        {
          order: 1,
          title: {
            en: 'How it works now',
            es: 'Cómo funciona ahora',
            pt: 'Como funciona agora',
          },
          body: {
            en: "Just select the token you want to deposit, confirm the amount, and you're done. No more multi-page forms.",
            es: 'Solo selecciona el token que quieres depositar, confirma el monto y listo. No más formularios de varias páginas.',
            pt: 'Basta selecionar o token que deseja depositar, confirmar o valor e pronto. Sem mais formulários de várias páginas.',
          },
          imageUrl:
            'https://img.freepik.com/vetores-gratis/painel-de-infografico-de-modelo-de-painel-de-usuario_23-2148378206.jpg?semt=ais_hybrid&w=740&q=80',
        },
      ],
      createdAt: '2026-03-01T00:00:00Z',
      expiresAt: '2026-04-01T00:00:00Z',
    },
  ],
};
